export default {
  // 按钮文本
  queryButton: '查询',
  addButton: '新增场景模型',
  editButton: '修改',
  deleteButton: '删除',
  cancelButton: '取消',
  confirmButton: '确定',

  // 表格列标题
  sceneNameColumn: '场景名称',
  sceneKeyColumn: '场景标识',
  algorithmNameColumn: '算法名称',
  extraAlgorithmColumn: '附加算法',
  modelPathColumn: '模型路径',
  createTimeColumn: '创建时间',
  updateTimeColumn: '更新时间',
  actionColumn: '操作',

  // 表单标签
  sceneNameLabel: '场景名称',
  sceneKeyLabel: '场景标识',
  algorithmNameLabel: '算法名称',
  extraAlgorithmLabel: '附加算法',
  modelLabel: '模型',
  labelLabel: '标签',
  modelPathLabel: '模型路径',

  // 表单placeholder
  sceneKeyPlaceholder: '请输入场景标识',
  sceneNamePlaceholder: '例如：公安执法',
  sceneKeyExamplePlaceholder: '例如：public_security.person_count',
  algorithmNamePlaceholder: '例如：人员识别/计数',
  extraAlgorithmPlaceholder: '例如：目标检测/跟踪（ByteTrack/DeepSORT 任选）、跨帧去重计数、区域过滤',
  selectModelPlaceholder: '请选择模型',
  labelPlaceholder: '选择模型后自动填充',
  modelPathPlaceholder: '选择模型后自动填充',

  // 验证消息
  sceneNameRequired: '请输入场景名称',
  sceneKeyRequired: '请输入场景标识',
  algorithmNameRequired: '请输入算法名称',
  extraAlgorithmRequired: '请输入附加算法',
  modelRequired: '请选择模型',
  labelRequired: '请先选择模型',
  modelPathRequired: '请先选择模型',

  // 弹窗标题
  addTitle: '新增场景模型',
  editTitle: '修改场景模型',

  // 确认对话框
  deleteConfirm: '是否删除{name}',

  // 成功消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',
}
